module.exports = __webpack_public_path__ + "static/media/no-data.289f8eb5.svg";